module.exports = __webpack_public_path__ + "static/assets/59427b0798e6e6554db60a37e787a682.svg";